import React, { useEffect, useState } from 'react';
import { authFetch, getToken } from '../auth';

const CabinetsModal = ({ open, API_URL, onClose, onSelect }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!open) return;
    (async () => {
      setError('');
      setLoading(true);
      try {
        const res = await authFetch(`${API_URL}/cabinets`);
        if (!res.ok) throw new Error((await res.json().catch(() => ({}))).message || 'Failed to load cabinets');
        const rows = await res.json();
        setItems(Array.isArray(rows) ? rows : []);
      } catch (e) {
        setError(e.message || 'Failed to load cabinets');
      } finally {
        setLoading(false);
      }
    })();
  }, [open, API_URL]);

  if (!open) return null;

  return (
    <div style={overlay}>
      <div style={modal}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0 }}>Select Cabinet</h3>
          <button className="btn btn-clear" onClick={onClose} disabled={loading}>Close</button>
        </div>
        {error && <div style={{ color: 'var(--danger)', marginTop: 8 }}>{error}</div>}
        <div style={{ marginTop: 12 }}>
          {loading ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={spinner}></div>
              <div>Loading cabinets…</div>
            </div>
          ) : (
            <div style={grid}>
              {items.map(item => (
                <button
                  key={item.id}
                  onClick={() => onSelect && onSelect(item)}
                  className="btn btn-ghost"
                  style={card}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={logoBox}>
                      {item.has_logo ? (
                        <img
                          alt={item.name}
                          src={`${API_URL}/cabinets/${item.id}/logo?token=${encodeURIComponent(getToken()||'')}`}
                          style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                        />
                      ) : (
                        <div style={{ fontSize: 22 }}>🗄️</div>
                      )}
                    </div>
                    <div style={{ textAlign: 'left', fontWeight: 600 }}>{item.name}</div>
                  </div>
                </button>
              ))}
              {(!items || items.length === 0) && (
                <div style={{ color: 'var(--text-soft)' }}>No cabinets found.</div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const overlay = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1001, display: 'flex', alignItems: 'center', justifyContent: 'center' };
const modal = { width: 600, maxWidth: '95vw', background: 'var(--modal-bg)', color: 'var(--text)', borderRadius: 8, padding: 16, boxShadow: '0 10px 30px rgba(0,0,0,0.4)' };
const grid = { display: 'grid', gridTemplateColumns: '1fr', gap: 12 };
const card = { width: '100%', textAlign: 'left', padding: 12, border: '1px solid var(--border)', borderRadius: 8, background: 'var(--card-bg)' };
const logoBox = { width: 44, height: 44, borderRadius: 6, background: 'var(--hover-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center' };
const spinner = { border: '6px solid #e0e0e0', borderTop: '6px solid #1565c0', borderRadius: '50%', width: 36, height: 36, animation: 'spin 1s linear infinite' };
// verticalName no longer used

export default CabinetsModal;
